import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		companySettingsHeader: {
			alignItems: 'center',
			height: 'auto',
			backgroundColor: '#ebebeb',
			'-webkit-box-shadow': '0px 1px 5px 0px rgba(235,235,235,1)',
			'-moz-box-shadow': '0px 1px 5px 0px rgba(235, 235, 235, 1)',
			boxShadow: '0px 1px 5px 0px rgba(235, 235, 235, 1)',
			flexFlow: 'column',
		},
		entityHeaderContent: {
			justifyContent: 'space-between',
			maxWidth: '670px',
			paddingLeft: '10px',
			paddingRight: '10px',
			width: '100%',
			height: '100%',
			position: 'relative',
			marginTop: '10px',
		},
		tabLabelContainer: {
			color: '#424242',
			fontFamily: 'Roboto',
			fontSize: '16px',
			fontWeight: 500,
			cursor: 'pointer',
			marginRight: '28px',
			paddingBottom: '10px',
			[theme.breakpoints.down('md')]: {
				fontSize: '14px',
			},
		},
		selectedTabLabelContainer: {
			color: '#1b1a7c',
			borderBottom: '3px solid',
			cursor: 'initial',
		},
		deleteButton: {
			marginLeft: 'auto',
		},
		detailsSection: {
			flexFlow: 'column',
			marginTop: '10px',
		},
		logoContainer: {
			display: 'flex',
			flexDirection: 'row',
		},
		logo: {
			width: '60px',
			height: '60px',
			borderRadius: '50%',
			border: '1px solid #e1e1f4',
			backgroundColor: '#fff',
		},
		titleSection: {
			display: 'flex',
			flexFlow: 'column',
			marginTop: '10px',
			marginBottom: '10px',
		},
		title: {
			color: '#1b1a7c',
			fontSize: '28px',
			fontWeight: 300,
		},
		subTitle: {
			color: '#929292',
			fontSize: '14px',
			maxWidth: '450px',
		},
		goBack: {
			position: 'absolute',
			top: 90,
			left: 10,
		},
		backBtn: {
			// position: 'absolute',
			// top: '35px',
			// left: '-150px',
			height: 30,
			width: 100,
			background: 'rgba(0, 0, 0, 0.2)',
			color: '#fff',
			border: '1px solid #fff',
			borderRadius: '20px',
			padding: '0px 20px',
			paddingRight: '25px',
			alignItems: 'center',
			textTransform: 'none',
			marginBottom: 15,
		},
		backBtnText: {
			paddingRight: '2px',
		},
		logoBox: {
			marginRight: '10px',
			display: 'flex',
			flexDirection: 'column',
			// justifyContent: 'space-between',
		},
		avatar: {
			width: 60,
			height: 60,
			'& img': {
				backgroundColor: 'white',
				objectFit: 'contain',
			},
		},
		breadcrumbsContainer: {
			padding: '4px 0px 0px 20px',
		},
		backBtnBreadcrumbsContainer: {
			position: 'relative',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
		},
	})
